import { Pipe, PipeTransform } from '@angular/core';
import { leaveLabel } from '../constants/constants';
/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | exponentialStrength:exponent
 * Example:
 *   {{ 2 | exponentialStrength:10 }}
 *   formats to: 1024
*/
@Pipe({ name: 'stateImage' })
export class StateImagePipe implements PipeTransform {
  transform(value: string, place: string): string {

    let statusLabel = {
      "Headquarter": "assets/imgs/Status-Headquarter.png",
      "Leave": "assets/imgs/Status-Leave.png",
      "Bank Holiday": "assets/imgs/Status-Holiday.png",
      "Travel": "assets/imgs/Status-Travel.png",
    };

    if (place) {
      if (value.indexOf(place) > -1)
        return statusLabel.Travel;
      else
        return statusLabel["Bank Holiday"];
    } else {
      for (let i in statusLabel) {
        if (value == i) {
          return statusLabel[i];
        } else if (leaveLabel.indexOf(value) > -1){
          return statusLabel.Leave;
        }
      }
    }

    return statusLabel.Travel;
  }
}


// WEBPACK FOOTER //
// ./src/pipes/state-img.pipe.ts